<template>
  <div class="add-new-customer">
    <title-bar
      submitBtn
      submitBtnTitle="Save settings"
      title="Settings"
      @submitPressed="submitPressed"
    />
    <h2>User settings</h2>
    <employee-form v-if="user" entity="User" :requiredRole="false" :userObject="user" :action="action" @clearAction="action = null" />
    <h2>System settings</h2>
    <settings-form v-if="userData.role === 'ROLE_ADMIN'" entity="Settings" :action="action" @clearAction="action = null" />
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import EmployeeForm from '../Employees/components/EmployeeForm.vue'
import SettingsForm from './components/SettingsForm.vue'
import {getUserData} from "@/auth/utils"

export default {
  components: {
    TitleBar,
    EmployeeForm,
    SettingsForm
  },
  data() {
    return {
      action: null,
      user: null,
      userData: getUserData(),
    }
  },
  created() {
    this.load()
  },
  methods: {
    load(){
      this.$Users.getResource({ id: getUserData().id }).then(response => {
        this.user = response.data
      })
    },
    submitPressed() {
      this.action = 'update'
    }
  },
}
</script>
